import { USER_PLAN, SELECTED_UPGRADE } from "../apollo/queries"
import { getAuthenticatedUser } from "./auth"
import { safeReadQuery } from "./helpers/graphql"
import client from "../apollo/client"
import VERSION from "../version"

export const getUser = () => {
  let user = {}
  const authenticated = getAuthenticatedUser()
  user = authenticated ? authenticated : user
  const userPlan = getUserPlan()
  user.isPremium = !!userPlan && userPlan !== "plan-free"
  user.accountPlan = !!userPlan ? userPlan : "plan-free"
  //console.log("LOG: [User] getCurrentUser", { user })
  return user
}

export const getUserPlan = () => {
  const { userPlan } = safeReadQuery(USER_PLAN, {
    userPlan: "plan-free",
  })
  return userPlan
}

/**
 *  Sets the user to the provided plan ID.  If plan ID is left
 *  empty, it will set the user to the plan they've selected during
 *  checkout process.  Used to set a user's plan after retrieved
 *  from the database.
 * @param {String} plan the plan id (ie, plan-monthly)
 */
export const setUserPlan = plan => {
  const selectedPlan = plan
    ? plan
    : safeReadQuery(SELECTED_UPGRADE, {
        selectedUpgradePlan: "plan-monthly",
      }).selectedUpgradePlan

  // Update the user's plan
  console.log("LOG: [setUserPlan] set user plan to:", selectedPlan)
  client.writeData({ data: { userPlan: selectedPlan } })
  //Update helpscout metadata with plan
  // setupServicesUser()
}

export const setupServicesUser = user => {
  user = user ? user : getUser()

  window.Beacon &&
    window.Beacon("identify", {
      name: user.displayName,
      version: VERSION.number,
      email: user.email,
      plan: getUserPlan(),
    })
}
